module.exports = __webpack_public_path__ + "img/NI.b57044db.svg";